import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useChangeCoverageOrcaCa } from './hooks/useChangeCoverageOrcaCa';
import { PolicyHeader } from '../PolicyHeader';

import errorImage from '../../../assets/changeCoverage/on-error.svg';

import { globalContactUsModalToggled } from '../../../actions';

import checkoutStyles from './css/ChangeCoverageOrcaCheckout.module.css';
import styles from './css/ChangeCoverageOrcaError.module.css';
import { useUpToTop } from '../../../hooks';

export const ChangeCoverageOrcaError = () => {
  const { t } = useTranslation('changeCoverage');
  const dispatch = useDispatch();

  const { marketingChanelId } = useChangeCoverageOrcaCa();

  const onContactUs = () => {
    dispatch(globalContactUsModalToggled());
  };

  useUpToTop();

  return (
    <div className={checkoutStyles.checkout}>
      <h1>{t('errorScreen.title')}</h1>

      <div className={`Colors-${marketingChanelId} Width-full`}>
        <PolicyHeader
          company={+marketingChanelId}
          logoClass="Change-coverage-header-logo"
        />

        <div className={checkoutStyles.checkoutContainer}>
          <div className={styles.error}>
            <img alt="" src={errorImage} />

            <h3>{t('errorScreen.subTitle')}</h3>

            <p>
              <span>{t('errorScreen.footer')}</span>

              <br />

              <span>
                <Trans
                  components={{
                    a: (
                      <button
                        className={styles.successContactUs}
                        onClick={onContactUs}
                        type="button"
                      />
                    ),
                  }}
                  i18nKey="errorScreen.contactUs"
                  ns="changeCoverage"
                />
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
